import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";
import { useAppSelector } from "store/index";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;
  handleUpdateStatus: (e: { value: string | number; label: string }[]) => void;
  selectedStatus: { value: string | number; label: string }[];
  handleUpdateCurrency: (
    e: { value: string | number; label: string }[]
  ) => void;
  selectedCurrency: { value: string | number; label: string }[];
  handleApply: () => void;
  handleUpdateActive: (e: { value: string | number; label: string }[]) => void;
  selectedActive: { value: string | number; label: string }[];
}
const TournamentsFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,
  handleUpdateStatus,
  selectedStatus,
  handleUpdateCurrency,
  selectedCurrency,
  handleApply,
  handleUpdateActive,
  selectedActive,
}) => {
  const { t } = useTranslation();

  const currenciesList = useAppSelector((store) => store.settings.currencies);

  const [Status, setStatus] = useState<
    { value: string | number; label: string }[]
  >([]);

  const getStatus = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.tournamentsStatusesList}?limit=500&offset=0`
      );
      const array = result.data.items.map((el: any) => {
        return {
          value: el.id,
          label: el.title,
        };
      });
      setStatus(array);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getStatus();
  }, []);

  const handleApplyStatus = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateStatus && selectedStatus)
      handleUpdateStatus(isDelete ? e : [...e]);
  };
  const handleApplyCurrency = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateCurrency && selectedCurrency)
      handleUpdateCurrency(isDelete ? e : [...selectedCurrency, ...e]);
  };
  const handleApplyActive = (
    e: { value: string | number; label: string }[]
  ) => {
    handleUpdateActive(e);
  };

  const handleClearFilters = () => {
    handleUpdateStatus([]);
    handleUpdateCurrency([]);
    handleApplyActive([{ value: 3, label: "All" }]);
    handleSearch("");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      className="tournaments-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: selectedActive,
          handleApply: handleApplyActive,
        },
        {
          type: FilterItemTypes.select,
          title: t("status"),
          boxTitle: t("status"),
          icon: gridIcon,
          itemsArray: Status,
          activeItems: selectedStatus,
          handleApply: handleApplyStatus,
          disabled: Status.length === 0,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("currency"),
          boxTitle: t("currency"),
          icon: gridIcon,
          itemsArray: currenciesList.map((el) => ({ label: el, value: el })),
          activeItems: selectedCurrency,
          handleApply: handleApplyCurrency,
          disabled: currenciesList.length === 0,
        },
      ]}
    />
  );
};

export default TournamentsFilter;
